<template>
  <div class="hzc-price-index">
    <div class="back">当前位置：<span style="cursor: pointer" @click="back('/powerCoal')">动力煤</span> > <span
        @click="back('/powerCoal/twoPage/enterprise')" style="cursor: pointer">重点企业资讯</span> > 正文
    </div>
    <DetailTitle :title="endTime + '煤炭重点企业资讯'"></DetailTitle>
    <div class="hzc-echarts">
      <div class="echarts">
        <div class="title"><span></span>
          <p>23家地方矿  原煤+精煤 库存信息(万吨)</p></div>
        <div id="myChart" style="width: 600px;height:340px;"></div>
      </div>
      <div class="echarts">
        <div class="title"><span></span>
          <p>18家洗煤厂 原煤+精煤 库存信息(万吨)</p></div>
        <div id="myChart1" style="width: 600px;height:340px;"></div>
      </div>
      <div class="echarts">
        <div class="title"><span></span>
          <p>大矿 23个矿点原煤+精煤库存信息(万吨)</p></div>
        <div id="myChart2" style="width: 600px;height:340px;"></div>
      </div>
      <div class="echarts">
        <div class="title"><span></span>
          <p>开工率% (大矿、地方矿、洗煤厂平均)</p></div>
        <div id="myChart3" style="width: 600px;height:340px;"></div>
      </div>
    </div>
    <el-table
        :data="tableData"
        :header-cell-style="{background:'#f2f2f2',color:'#222'}"
        height="700"
        border
        style="width: 100%;margin-top: 20px;margin-bottom: 30px">
      <el-table-column
          type="index"
          label="序号"
          fixed
          width="50">
      </el-table-column>
      <el-table-column
          align="left"
          prop="type"
          label="类型">
      </el-table-column>
      <el-table-column
          align="center"
          prop="coalName"
          label="矿点">
      </el-table-column>
      <el-table-column
          align="center"
          prop="supplier"
          label="隶属公司">
      </el-table-column>
      <el-table-column
          align="center"
          label="省/市/县">
        <template slot-scope="scope">
          <span>{{scope.row.provinceName + scope.row.cityName}}</span>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="originalStorage"
          label="原煤库存(万吨)">
      </el-table-column>
      <el-table-column
          align="center"
          prop="refineStorage"
          label="精煤库存(万吨)">
      </el-table-column>
      <el-table-column
          align="center"
          prop="mineralRatio"
          label="开工率(%)">
      </el-table-column>
      <el-table-column
          align="center"
          prop="recoveryRat"
          label="原煤回收率(%)">
      </el-table-column>
      <el-table-column
          align="center"
          prop="oreDrawingPrice"
          label="煤矿出矿价格(元/吨)">
      </el-table-column>
      <el-table-column
          align="center"
          prop="toWashPrice"
          label="洗煤厂到厂价(元/吨)">
      </el-table-column>
      <el-table-column
          align="center"
          prop="sales"
          label="销售情况">
      </el-table-column>
      <el-table-column
          align="center"
          prop="remark"
          label="简要说明">
      </el-table-column>
      <el-table-column
          align="center"
          prop="createBy"
          label="业务员">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import DetailTitle from '@/components/common/detatilTitle'
import {examineDetail} from '@/api/coal'
import {examineDetailEcharts} from "@/api/steel";

export default {
  components: {
    DetailTitle
  },
  data() {
    return {
      endTime: '',
      tableData: [],
      option: {
        title: {
          // text: ""
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
          data: ['地方矿库存'],
          textStyle: {//图例文字的样式
            color: '#EE6666',
          },
          color: '#EE6666'
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月']
        },
        yAxis: {},
        series: [
          {
            name: "地方矿库存",
            type: "line",
            data: [5, 20, 36, 10, 10, 20],
            lineStyle: {
              color: '#EE6666' //改变折线颜色
            },
            itemStyle: {
              normal: {
                color: '#EE6666',
              }
            },
          },
        ],
        grid: {
          x: 50,
          y: 50,
          x2: 10,
          y2: 50
        },
      },
      option1: {
        title: {
          // text: ""
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
          data: ['洗煤厂库存'],
          textStyle: {//图例文字的样式
            color: '#5470C6',
          },
          color: '#5470C6'
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月']
        },
        yAxis: {},
        series: [
          {
            name: "洗煤厂库存",
            type: "line",
            data: [5, 20, 36, 10, 10, 20],
            lineStyle: {
              color: '#5470C6' //改变折线颜色
            },
            itemStyle: {
              normal: {
                color: '#5470C6',
              }
            },
          },
        ],
        grid: {
          x: 50,
          y: 50,
          x2: 10,
          y2: 50
        },
      },
      option2: {
        title: {
          // text: ""
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
          data: ['大矿库存'],
          textStyle: {//图例文字的样式
            color: '#469F5A',
          },
          color: '#469F5A'
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月']
        },
        yAxis: {},
        series: [
          {
            name: "大矿库存",
            type: "line",
            data: [5, 20, 36, 10, 10, 20],
            lineStyle: {
              color: '#469F5A' //改变折线颜色
            },
            itemStyle: {
              normal: {
                color: '#469F5A',
              }
            },
          },
        ],
        grid: {
          x: 50,
          y: 50,
          x2: 10,
          y2: 50
        },
      },
      option3: {
        title: {
          // text: ""
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
          data: ['开工率'],
          textStyle: {//图例文字的样式
            color: '#73C0DE',
          },
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月']
        },
        yAxis: {},
        series: [
          {
            name: "开工率",
            type: "line",
            data: [5, 20, 36, 10, 10, 20],
            lineStyle: {
              color: '#73C0DE' //改变折线颜色
            },
            itemStyle: {
              normal: {
                color: '#73C0DE',
              }
            },
          },
        ],
        grid: {
          x: 50,
          y: 50,
          x2: 10,
          y2: 50
        },
      }
    }
  },
  created() {
    this.endTime = this.$route.query.id;
    this.getDetail()
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      examineDetail({collectionTime: this.endTime}).then(res => {
        this.tableData = res.data.dataList;
        this.option['xAxis']['data'] = res.data['timeList']
        this.option1['xAxis']['data'] = res.data['timeList']
        this.option2['xAxis']['data'] = res.data['timeList']
        this.option3['xAxis']['data'] = res.data['timeList']
        this.option['series'][0]['data'] = res.data['localMineList']
        this.drawChart(this.option);
        this.option1['series'][0]['data'] = res.data['washCokeList']
        this.drawChart1(this.option1);
        this.option2['series'][0]['data'] = res.data['bigMineList']
        this.drawChart2(this.option2);
        this.option3['series'][0]['data'] = res.data['rateList']
        this.drawChart3(this.option3);
      })
    },
    /**
     * 加载地图
     */
    drawChart(option) {
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      myChart.setOption(option);
    },
    drawChart1(option) {
      let myChart = this.$echarts.init(document.getElementById("myChart1"));
      myChart.setOption(option);
    },
    drawChart2(option) {
      let myChart = this.$echarts.init(document.getElementById("myChart2"));
      myChart.setOption(option);
    },
    drawChart3(option) {
      let myChart = this.$echarts.init(document.getElementById("myChart3"));
      myChart.setOption(option);
    },
    back(url) {
      this.$router.push({path: url});
    },
  },
}
</script>

<style scoped lang="less">
.hzc-price-index {
  width: 1200px;
  margin: 0 auto;

  .slot-span {
    display: inline-block;
    text-align: center;
    line-height: 25px;
    width: 74px;
    height: 25px;
    background: #F2F2F2;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    cursor: pointer;
  }

  .slot-span:hover {
    background-color: #D3131A;
    border: 1px solid #D3131A;
    color: #fff;
  }

  .slot-hover {
    background-color: #D3131A;
    border: 1px solid #D3131A;
    color: #fff;
  }
}

.hzc-echarts {
  //background: #FFFFFF;
  //margin-top: 20px;
}

.echarts {
  position: relative;
  display: inline-block;
  margin-top: 24px;
  //width: 00px;
  height: 351px;

  .title {
    position: absolute;

    span {
      display: inline-block;
      width: 4px;
      height: 16px;
      background: #D3131A;
      vertical-align: middle;
    }

    p {
      display: inline-block;
      vertical-align: middle;
      font-size: 16px;
      font-weight: 500;
      color: #222;
      margin-left: 10px;
    }
  }
}
</style>
